import CryptoJS from "crypto-js";
import { Get, GetFixed, GetLog, Post } from "@/request/http";

// 导出各个Api文件的接口
export * from "./login";
export * from "./orders";

// 获取配置接口（固定域名，不参与云控——云控的域名就是它下发的）
export const getConfig = (data: any) => GetFixed("/workai/index/config", data);
// 启动阶段拉同一份配置：所有请求都在等它下发域名，超时压到 5s
export const getBootstrapConfig = (data: any) => GetFixed("/workai/index/config", data, 5000);
// 埋点验签盐值（与日志服务约定，勿改）
const LOG_SIGN_SALT = "toiu297gfHSdguirTw5ea6uSDksaWvjL";

// 埋点是旁路行为，失败只记日志、绝不 reject。
// 否则调用方一旦漏了 catch（裸 await），埋点报错就会中断安装、跳转、关闭登录弹窗这些业务流程。
function reportLog(url: string, label: string) {
    return GetLog(url).catch((err) => {
        console.error(`[埋点] ${label}上报失败`, url, err);
    });
}

/**
 * 埋点日志——路径形式（走云控下发的 track_log 域名），需要验签。
 * 业务代码请调 utils/track.ts 的 track(key)，别直接用这个（渠道信息与两种格式的分发都收在那里）
 * /office/log/log/{key}/{channel}/{ver}/{sys}/{guid}?timestamp={13位毫秒}&sign={md5}
 * sign = MD5(带 timestamp 的完整 path + 盐值)，参与签名的串不含域名，且 sign 本身不参与签名
 * @param {String} url 形如 `/appStartUp/${channel}/${ver}/${sys}/${guid}`
 */
export const TrackLog = (url) => {
    const timestamp = Date.now();
    // 这里拼出来的串必须和最终请求的 path + query 逐字节一致，否则服务端算出的 sign 对不上
    const raw = `/office/log/log${url}?timestamp=${timestamp}`;
    const sign = CryptoJS.MD5(raw + LOG_SIGN_SALT).toString();
    return reportLog(`${raw}&sign=${sign}`, "路径形式");
};

/**
 * 埋点日志——query 形式，与 TrackLog 并存，同一个动作两种格式各报一次，同样需要验签。
 * 同上：业务代码走 utils/track.ts 的 track(key)
 * /workai/log/log?key=&channel=&ver=&sys=&guid=&timestamp={13位毫秒}&sign={md5}
 * sign = MD5(带 timestamp 的完整 path+query + 盐值)，参数顺序固定，sign 自身不参与签名
 * @param {String} key 埋点事件名（与路径形式的第一段一致）
 * @param {String} channel 渠道号
 * @param {String} ver 客户端版本
 * @param {String} sys 系统版本
 * @param {String} guid 设备唯一标识
 */
export const TrackLogQuery = (key, channel, ver, sys, guid) => {
    const timestamp = Date.now();
    // 同上：签名的串必须和最终请求的 path+query 逐字节一致，所以不走 axios 的 params
    const raw = `/workai/log/log?key=${key}&channel=${channel}&ver=${ver}&sys=${sys}&guid=${guid}&timestamp=${timestamp}`;
    const sign = CryptoJS.MD5(raw + LOG_SIGN_SALT).toString();
    return reportLog(`${raw}&sign=${sign}`, "query 形式");
};